import { IconButton, Tooltip } from "@mui/material";
import { DataWrapper } from "../../interfaces/DataWrapper";
import { PostPreference } from "../../interfaces/PostPreference";
import PreferencesService from "../../services/preferences.service";
import { useErrorBoundary } from "react-error-boundary";
import { Notifications as NotificationsIcon, NotificationsOff as NotificationsOffIcon } from '@mui/icons-material';
import { UserPreference } from "../../interfaces/UserPreference";

const SubscribeButton = ({preference, onSuccess}: {preference: UserPreference, onSuccess: () => void}) => {
  const { showBoundary } = useErrorBoundary();

  const subscribeButtonHandler = async (id: number, isSubscribed: boolean) => {
    const updateData: DataWrapper<Partial<PostPreference>> = {
      data: {
        receiveNotifications: !isSubscribed,
      },
    };

    await PreferencesService.update(id, updateData)
      .then(() => {
        onSuccess();
      })
      .catch((error) => showBoundary(error));
  };

  return <Tooltip title={preference.receiveNotifications ? 'Unsubscribe' : 'Subscribe'}>
    <IconButton onClick={() => subscribeButtonHandler(preference.id, preference.receiveNotifications)}>
      {preference.receiveNotifications ? <NotificationsIcon /> : <NotificationsOffIcon />}
    </IconButton>
  </Tooltip>
};

export default SubscribeButton;
